//import React, { useState } from "react";
import React, { useState, useEffect } from "react";
import { useUI } from "../context/UIContext";
import { ReportAPI ,ProjectAPI} from "../api/apiClient";
import { toast } from "react-hot-toast";
import PeriodReport from "./PeriodReport";
import SnapshotReport from "./SnapshotReport";
//import ManpowerTotalReport from "./reports/ManpowerTotalReport";





// Types 
type SnapshotResult = any;
type PeriodResult = any;

export default function ProjectReports() {
  const { selectedProjectId,selectedProjectName, setViewMode, pushUIState,  setGanttAsOnDate   // ✅ ADD THIS
  } = useUI();

  const [reportType, setReportType] = useState<
    "menu" | "snapshot" | "period" | "gantt"      | "snapshot-results" | "period-results"   
               // ✅ ADD | "manpower-total"
  >("menu");

  // ✅ ADD THIS LINE
  const today = new Date().toISOString().split("T")[0];
//  const [snapshotDate, setSnapshotDate] = useState<string>("");

  const [snapshotDate, setSnapshotDate] = useState<string>(today);
  const [taskGroup, setTaskGroup] = useState("");

const [taskGroups, setTaskGroups] = useState<
  { taskGroupNo: number; taskGroupName: string }[]
>([]);

 // const [fromDate, setFromDate] = useState<string>("");
  //const [toDate, setToDate] = useState<string>("");
  const todayDate = new Date();
const lastWeekDate = new Date();
lastWeekDate.setDate(todayDate.getDate() - 7);

const defaultTo = todayDate.toISOString().split("T")[0];
const defaultFrom = lastWeekDate.toISOString().split("T")[0];

const [fromDate, setFromDate] = useState<string>(defaultFrom);
const [toDate, setToDate] = useState<string>(defaultTo);

  const [snapshotResult, setSnapshotResult] = useState<SnapshotResult | null>(null);
  const [periodResult, setPeriodResult] = useState<PeriodResult | null>(null);


  useEffect(() => {
  if (!selectedProjectId) return;

  ProjectAPI.getTaskGroups(selectedProjectId)
    .then(setTaskGroups)
    .catch(console.error);
}, [selectedProjectId]);
  if (!selectedProjectId)
    return <div className="p-4 text-red-600">No project selected.</div>;

  // -------------------------
  // API ACTIONS
  // -------------------------
  const runSnapshot = async () => {
    if (!snapshotDate) return toast.error("Select a date");

    try {
      const res = await ReportAPI.getSnapshotReport(
        selectedProjectId,
        snapshotDate,
        taskGroup
      );
      setSnapshotResult(res);
      setReportType("snapshot-results");
    } catch (err: any) {
      toast.error(err.message || "Snapshot failed");
    }
  };

  const runPeriod = async () => {
    if (!fromDate || !toDate)
      return toast.error("Select both dates");

    try {
      const res = await ReportAPI.getPeriodReport(
        selectedProjectId,
        fromDate,
        toDate,
        taskGroup
      );
      setPeriodResult(res);
      setReportType("period-results");
    } catch (err: any) {
      toast.error(err.message || "Period report failed");
    }
  };

  // -------------------------
  // UI PANELS
  // -------------------------

  const showMenu = (
    //<div className="p-6 space-y-6 max-w-xl">
   /// <div className="p-6 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
   // /*<div className="p-6 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
      //<h2 className="text-2xl font-bold mb-4">Project Reports</h2>
      <div className="p-6 max-w-7xl mx-auto">
  <h2 className="text-2xl font-bold mb-6">Project Reports</h2>

 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch">
      {/*<button
        onClick={() => setReportType("snapshot")}
        className="w-full p-4 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700"
      >
        📌 Snapshot Report (To Date)
      </button>

      <button
        onClick={() => setReportType("period")}
        className="w-full p-4 bg-green-600 text-white rounded-lg shadow hover:bg-green-700"
      >
        📅 Period Report (From → To)
      </button>*/}
{/*<div className="bg-white rounded-2xl shadow-lg border p-6">*/}
  <div className="bg-white rounded-2xl shadow-lg border p-6 h-full flex flex-col">
  <h2 className="text-xl font-bold text-gray-800 mb-4">
    📊 Issue Reports
  </h2>

  {/*<div className="grid grid-cols-1 sm:grid-cols-3 gap-4">*/}
 <div className="grid grid-cols-2 gap-4 flex-1">
    
    <div
      onClick={() => setReportType("snapshot")}
      //className="cursor-pointer p-5 rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📌</div>
      <div className="font-semibold">Snapshot Report</div>
    </div>

    <div
      onClick={() => setReportType("period")}
     // className="cursor-pointer p-5 rounded-xl bg-green-50 hover:bg-green-100 hover:scale-105 transition text-center"
     className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📅</div>
      <div className="font-semibold">Period Report</div>
    </div>

    <div
      onClick={() => {
        pushUIState();
        setViewMode("task-report");
      }}
     // className="cursor-pointer p-5 rounded-xl bg-indigo-50 hover:bg-indigo-100 hover:scale-105 transition text-center"
     className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📋</div>
      <div className="font-semibold">Task Report</div>
    </div>

  </div>
</div>

{/*<div className="bg-white rounded-2xl shadow-lg border p-6">*/}
<div className="bg-white rounded-2xl shadow-lg border p-6 h-full flex flex-col">
  <h2 className="text-xl font-bold text-gray-800 mb-4">
    📈 Progress Reports
  </h2>

 {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">*/}
<div className="grid grid-cols-2 gap-4 flex-1">

    {/* Gantt */}
    <div
      onClick={() => setReportType("gantt")}
    //  className="cursor-pointer p-5 rounded-xl bg-purple-50 hover:bg-purple-100 hover:scale-105 transition text-center"
    className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📊</div>
      <div className="font-semibold">Gantt Chart</div>
    </div>

    {/* Works Progress */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("works-progress-report");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-indigo-50 hover:bg-indigo-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">🏗️</div>
      <div className="font-semibold">Works Progress</div>
    </div>

    {/* Group Progress */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("group-report");
      }}
    //  className="cursor-pointer p-5 rounded-xl bg-teal-50 hover:bg-teal-100 hover:scale-105 transition text-center"
    className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📊</div>
      <div className="font-semibold">Group Progress</div>
    </div>

    {/* Markwise */}
    <div
      onClick={() => {
        const url = `/markwise-progress?projectId=${selectedProjectId}&projectName=${encodeURIComponent(selectedProjectName || "")}`;
        const newTab = window.open("", "_blank");
        if (newTab) newTab.location.href = url;
      }}
     // className="cursor-pointer p-5 rounded-xl bg-cyan-50 hover:bg-cyan-100 hover:scale-105 transition text-center"
     className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📈</div>
      <div className="font-semibold">Markwise Progress</div>
    </div>

  </div>
</div>

{/*<div className="bg-white rounded-2xl shadow-lg border p-6">*/}
<div className="bg-white rounded-2xl shadow-lg border p-6 h-full flex flex-col">
  <h2 className="text-xl font-bold text-gray-800 mb-4">
    📑 Statement Reports
  </h2>

 {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">*/}
 <div className="grid grid-cols-2 gap-4 flex-1">

    {/* Material Statement */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("material-statement");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-orange-50 hover:bg-orange-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">🧱</div>
      <div className="font-semibold">Material Statement</div>
    </div>

    {/* Material Vendor */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("material-statement-vendor-wise");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-amber-50 hover:bg-amber-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📦</div>
      <div className="font-semibold">Material Vendor Wise</div>
    </div>

    {/* Manpower Vendor */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("manpower-statement-vendor-wise");
      }}
    //  className="cursor-pointer p-5 rounded-xl bg-sky-50 hover:bg-sky-100 hover:scale-105 transition text-center"
    className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">👷</div>
      <div className="font-semibold">Manpower Vendor Wise</div>
    </div>

    {/* Manpower Resource */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("manpower-statement-resource-wise");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-emerald-50 hover:bg-emerald-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">👥</div>
      <div className="font-semibold">Manpower Resource Wise</div>
    </div>

    {/* Equipment Resource */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("equipment-statement-resource-wise");
      }}
     // className="cursor-pointer p-5 rounded-xl bg-slate-50 hover:bg-slate-100 hover:scale-105 transition text-center"
     className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">🚜</div>
      <div className="font-semibold">Equipment Resource Wise</div>
    </div>

    {/* Equipment Vendor */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("equipment-statement-vendor-wise");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-teal-50 hover:bg-teal-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">⚙️</div>
      <div className="font-semibold">Equipment Vendor Wise</div>
    </div>

  </div>
</div>

   {/* <div className="bg-white rounded-2xl shadow-lg border p-6">*/}
   <div className="bg-white rounded-2xl shadow-lg border p-6 h-full flex flex-col">
  <h2 className="text-xl font-bold text-gray-800 mb-4">
    📌 Information Reports
  </h2>

  {/*<div className="grid grid-cols-1 sm:grid-cols-2 gap-4">*/}
 <div className="grid grid-cols-2 gap-4 flex-1">
    {/* Drawings Report */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("drawings-report");
      }}
     // className="cursor-pointer p-5 rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
     className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">📐</div>
      <div className="font-semibold">Drawings Report</div>
    </div>

    {/* Weather Report */}
    <div
      onClick={() => {
        pushUIState();
        setViewMode("weather-keyword-report");
      }}
      //className="cursor-pointer p-5 rounded-xl bg-indigo-50 hover:bg-indigo-100 hover:scale-105 transition text-center"
      className="cursor-pointer h-[110px] flex flex-col justify-center items-center rounded-xl bg-blue-50 hover:bg-blue-100 hover:scale-105 transition text-center"
    >
      <div className="text-3xl mb-2">🌦</div>
      <div className="font-semibold">Weather Report</div>
    </div>

  </div>
</div> 
       

    {/*gantt Button*/}
   {/* <button
    onClick={() => setReportType("gantt")}
    className="w-full p-4 bg-purple-600 text-white rounded-lg shadow hover:bg-purple-700"
    >
      📊 Gantt Chart(As On Date)
    </button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("material-statement");
  }}
  className="w-full p-4 bg-orange-600 text-white rounded-lg shadow hover:bg-orange-700"
>
  🧱 Material Statement Report
</button>*/}


 {/*<button
  onClick={() => {
    pushUIState();
    setViewMode("works-progress-report");
  }}
 
  className="w-full p-4 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 transition"
>
  🏗️ Works Progress Report
</button>
<button
  onClick={() => {
    pushUIState();
    setViewMode("group-report");
  }}
 
  className="w-full p-4 bg-teal-600 text-white rounded-lg shadow hover:bg-teal-700 transition"
>
  📊 Group Progress Report
</button> */}


  

  {/*onClick={() => {
    pushUIState();
    setViewMode("markwise-progress");
  }}*/}
 
 {/*<button
  onClick={() => {
  const url = `/markwise-progress?projectId=${selectedProjectId}&projectName=${encodeURIComponent(selectedProjectName || "")}`;

  const newTab = window.open("", "_blank");
  if (newTab) {
    newTab.location.href = url;
  }
}}
  className="w-full p-4 bg-cyan-600 text-white rounded-lg shadow hover:bg-cyan-700 transition duration-200"
>
   📈 Markwise Progress Report
</button>*/}



{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("material-statement-vendor-wise");
  }}
  className="w-full p-4 bg-amber-500 text-white rounded-lg shadow hover:bg-amber-600 transition duration-200"
>
  📦 Material Statement Vendor Wise Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("manpower-statement-vendor-wise");
  }}
  className="w-full p-4 bg-sky-600 text-white rounded-lg shadow hover:bg-sky-700 transition duration-200"
>
  👷 ManPower Statement Vendor Wise Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("manpower-statement-resource-wise");
  }}
  className="w-full p-4 bg-emerald-600 text-white rounded-lg shadow hover:bg-emerald-700 transition duration-200"
>
  👥 ManPower Statement Resource Wise Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("equipment-statement-resource-wise");
  }}
  
  className="w-full p-4 bg-slate-600 text-white rounded-lg shadow hover:bg-slate-700 transition duration-200"
>
  🚜 Equipment Statement Resource Wise Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("drawings-report");
  }}
  className="w-full p-4 bg-blue-600 text-white rounded-lg shadow hover:bg-blue-700 transition duration-200"
>
  📐 Drawings Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("equipment-statement-vendor-wise");
  }}
 
 className="w-full p-4 bg-teal-700 text-white rounded-lg shadow hover:bg-teal-800 transition duration-200"
>
  ⚙️ Equipment Statement Vendor Wise
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("weather-keyword-report");
  }}
  className="w-full p-4 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700 transition duration-200"
>
🌦 Weather Keyword Report
</button>*/}

{/*<button
  onClick={() => {
    pushUIState();
    setViewMode("task-report");
  }}
  className="w-full p-4 bg-indigo-600 text-white rounded-lg shadow hover:bg-indigo-700"
>
  📋 Task Report
</button>*/}
      </div>
    </div>
     

  );

  


  const snapshotInput = (
    <div className="p-6 space-y-4 max-w-xl">
      <h2 className="text-xl font-bold">Snapshot Report</h2>

      <label className="block text-sm text-gray-700">To Date</label>
      <input
        type="date"
        value={snapshotDate}
        onChange={(e) => setSnapshotDate(e.target.value)}
        className="border p-2 rounded w-full"
      />

      <label className="block text-sm text-gray-700 mt-3">
  Filter by Task Group
</label>

<select
  value={taskGroup}
  onChange={(e) => setTaskGroup(e.target.value)}
  className="border p-2 rounded w-full"
>
  <option value="">All Task Groups</option>

  {taskGroups.map((g) => (
    <option key={g.taskGroupNo} value={g.taskGroupNo}>
      {g.taskGroupName}
    </option>
  ))}
</select>

      <div className="flex gap-3 mt-4">
        <button
          onClick={runSnapshot} 
          className="px-4 py-2 bg-blue-600 text-white rounded"
        >
          Run Report
        </button>

        <button
          onClick={() => setReportType("menu")}
          className="px-4 py-2 bg-gray-400 text-black rounded"
        >
          Back
        </button>
      </div>
    </div>
  );

  const periodInput = (
    <div className="p-6 space-y-4 max-w-xl">
      <h2 className="text-xl font-bold">Period Report</h2>

      <label className="block text-sm">From Date</label>
      <input
        type="date"
        value={fromDate}
        onChange={(e) => setFromDate(e.target.value)}
        className="border p-2 rounded w-full" 
      />

      <label className="block text-sm">To Date</label>
      <input
        type="date"
        value={toDate}
        onChange={(e) => setToDate(e.target.value)}
        className="border p-2 rounded w-full"
      />

      <label className="block text-sm text-gray-700 mt-3">
  Filter by Task Group
</label>

<select
  value={taskGroup}
  onChange={(e) => setTaskGroup(e.target.value)}
  className="border p-2 rounded w-full"
>
  <option value="">All Task Groups</option>

  {taskGroups.map((g) => (
    <option key={g.taskGroupNo} value={g.taskGroupNo}>
      {g.taskGroupName}
    </option>
  ))}
</select>

      <div className="flex gap-3 mt-4">
        <button
          onClick={runPeriod}
          className="px-4 py-2 bg-green-600 text-white rounded"
        >
          Run Report
        </button>

        <button
          onClick={() => setReportType("menu")}
          className="px-4 py-2 bg-gray-400 text-black rounded"
        >
          Back
        </button>
      </div>
    </div>
  );
  // -------------------------
// -------------------------
// GANTT DATE PICKER PANEL
// -------------------------
const ganttInput = (
  <div className="p-6 space-y-4 max-w-xl">
    <h2 className="text-xl font-bold">Gantt Chart</h2>

    <label className="block text-sm text-gray-700">As On Date</label>
    <input
      type="date"
      value={toDate}
      onChange={(e) => setToDate(e.target.value)}
      className="border p-2 rounded w-full"
    />

    <div className="flex gap-3 mt-4">
      <button
        onClick={() => {
          if (!toDate) {
            toast.error("Select a date");
            return;
          }

          /*pushUIState();
          setGanttAsOnDate(toDate); // ✅ VERY IMPORTANT
          setViewMode("project-gantt");*/
          // const url = `/gantt?date=${toDate}&projectId=${selectedProjectId}`;
          const url = `/gantt?date=${toDate}&projectId=${selectedProjectId}&projectName=${encodeURIComponent(selectedProjectName || "")}`;

    const newTab = window.open("", "_blank");
    if (newTab) {
      newTab.location.href = url;
    }
  }}
       // }}
        className="px-4 py-2 bg-purple-600 text-white rounded"
      >
        Run Report
      </button>

      <button
        onClick={() => setReportType("menu")}
        className="px-4 py-2 bg-gray-400 rounded"
      >
        Back
      </button>
    </div>
  </div>
);



















  const snapshotResults = snapshotResult && (
    <div className="p-6 space-y-4">
      <h2 className="text-xl font-bold">Snapshot Report Result</h2>
      {/* <SnapshotReport report={snapshotResult} /> */}
      <SnapshotReport
    report={snapshotResult}
    snapshotDate={snapshotDate}
    projectName={selectedProjectName}
/>

      <button
        onClick={() => setReportType("menu")}
        className="px-4 py-2 bg-gray-400 rounded"
      >
        Back
      </button>
    </div>
  );

  const periodResults = periodResult && (
    <div className="p-6 space-y-4 "> {/* h-[80vh] overflow-y-auto*/}
      <h2 className="text-xl font-bold">Period Report Result</h2>
      {/* <PeriodReport report={periodResult} /> */}
      <PeriodReport
    report={periodResult}
     projectName={selectedProjectName ?? ""}
    fromDate={fromDate}
    toDate={toDate}
/>

      <button
        onClick={() => setReportType("menu")}
        className="px-4 py-2 bg-gray-400 rounded"
      >
        Back
      </button>
    </div>
  );

  // -------------------------
  // SWITCH RENDER
  // -------------------------
  switch (reportType) {
    case "menu": 
      return showMenu;
    case "snapshot":
      return snapshotInput;
    case "period":
      return periodInput;
    case "snapshot-results":
      return snapshotResults;
    case "period-results":
      return periodResults;
    case "gantt":
    return ganttInput;
     //case "manpower-total":
   // return manpowerTotalView;
   

   
    default:
      return showMenu; 
  }
} 
